import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getLatestImportJobs = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/import-jobs/latest`);
    return response.data;
  } catch (error) {
    console.error('Error fetching import jobs:', error.response?.data || error);
    throw error;
  }
};

